import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';

export interface GeneralResponse {
    data: GeneralResponseBody;
    errors?: Array<string>;
}
export interface GeneralResponseBody {
    data: Array<ClaimType>;
    limit: number;
    message: string;
    page: number;
    totalCount: number;
    totalPages: number;
    warnings: Array<string>;
    count: number;
}
export interface ClaimType {
    id: string;
    code: string;
    name: string;
}

export interface ClaimTypePayload {
    policyTypeCode: string;
    claimCategoryCode: string;
}

export const fetchClaimTypes = createAction<fetchClaimTypesAction>(
    ActionTypes.FETCH_CLAIM_TYPES,
);
export const fetchClaimTypesSuccess =
    createAction<fetchClaimTypesSuccessAction>(
        ActionTypes.FETCH_CLAIM_TYPES_SUCCESS,
    );
export const fetchClaimTypesFailed = createAction<fetchClaimTypesFailedAction>(
    ActionTypes.FETCH_CLAIM_TYPES_FAILED,
);
export const fetchClaimTypesByPolicyTypeAndClaimCategory =
    createAction<fetchClaimTypesByPolicyTypeAndClaimCategoryAction>(
        ActionTypes.FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY,
    );
export const fetchClaimTypesByPolicyTypeAndClaimCategorySuccess =
    createAction<fetchClaimTypesByPolicyTypeAndClaimCategorySuccessAction>(
        ActionTypes.FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_SUCCESS,
    );
export const fetchClaimTypesByPolicyTypeAndClaimCategoryFailed =
    createAction<fetchClaimTypesByPolicyTypeAndClaimCategoryFailedAction>(
        ActionTypes.FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_FAILED,
    );
export const clearClaimTypesState = createAction<
    clearClaimCategoryStateAction | undefined
>(ActionTypes.CLEAR_CLAIM_TYPES_STATE);

export interface fetchClaimTypesAction {
    type: typeof ActionTypes.FETCH_CLAIM_TYPES;
}

export interface fetchClaimTypesSuccessAction {
    type: typeof ActionTypes.FETCH_CLAIM_TYPES_SUCCESS;
    payload: GeneralResponse;
}

export interface fetchClaimTypesFailedAction {
    type: typeof ActionTypes.FETCH_CLAIM_TYPES_FAILED;
    payload: any;
}
export interface fetchClaimTypesByPolicyTypeAndClaimCategoryAction {
    type: typeof ActionTypes.FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY;
    payload: ClaimTypePayload;
}

export interface fetchClaimTypesByPolicyTypeAndClaimCategorySuccessAction {
    type: typeof ActionTypes.FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_SUCCESS;
    body: GeneralResponse;
}

export interface fetchClaimTypesByPolicyTypeAndClaimCategoryFailedAction {
    type: typeof ActionTypes.FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_FAILED;
    body: GeneralResponse;
}

export interface clearClaimCategoryStateAction {
    type: typeof ActionTypes.CLEAR_CLAIM_CATEGORY_STATE;
}
